// @flow
import styled from 'styled-components'
import { Card } from 'antd'

export const StyledCard = styled(Card) `
  .ant-card-head-title {
    p {
      margin: 0;  
      span { 
        font-size: 10px;
        float: right;            
      } 
    }
   }
`

export const StyledLoadingDiv = styled.div`
  text-align: center;
  padding-top: 100px;
`

export const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  
  th, td {
      border: 1px solid black;
  }
  
  th { 
    background-color: #4471c4;
    color:white;
    height: 34px;
    padding-left: 10px;
    
    &:first-child { 
      background-color: #203863;
    }
  }
  
 .matrix {
    background-color: #4471c4;
    color:white;
    div { 
    transform: rotate(270deg);
            white-space: nowrap;
            transform-origin: 65px 60px;
        
    span{
   
      display:inline-block;
	    width:16px;
	    height:150px;
      }
    }  
  }
  .strategy {
    background-color: #d9e3f3;
  }
  
  ul { 
    list-style: none;
    padding: 0 7px;
    
    li {
        line-height: 15px;
        font-size: 12px;
    }
  }
`




// WEBPACK FOOTER //
// ./src/components/Admin/style.js